
import React from "react";
import { WebhookDebugger } from "@/components/campaigns/WebhookDebugger";

const WebhookDebug = () => {
  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-2xl font-bold">Debug de Webhook</h1>
        <p className="text-gray-500">
          Ferramenta de diagnóstico para webhooks de campanha
        </p>
      </header>

      <WebhookDebugger />
    </div>
  );
};

export default WebhookDebug;
